module.exports = __webpack_public_path__ + "img/1.d0a6d5dc.png";